module.exports = __webpack_public_path__ + "img/T1C_rc_17.f8053b94.png";